import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-user-activity",
  templateUrl: "./user-activity.component.html",
})
export class UserActivityComponent implements OnInit {
  @Input() public activity: any;
  public name: string;

  public ngOnInit() {
    const parameters = this.activity.parameters || {};
    this.name = parameters[":name"];
  }
}
